import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";

import { getFootage, getFootageIndustries, updateFootage } from "@app/services/footage";

export const footageKeys = {
  all: ["footage"],
  list: (filters) => [...footageKeys.all, "list", filters],
  industries: () => [...footageKeys.all, "industries"],
};

export const useFootage = (filters = {}, options = {}) => {
  return useInfiniteQuery({
    queryKey: footageKeys.list(filters),
    queryFn: ({ pageParam, signal }) =>
      getFootage({ ...filters, page: pageParam }, { signal }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    meta: {
      errorMessage: "Failed to load footage. Please try again.",
    },
    ...options,
  });
};

export const useFootageIndustries = (options = {}) => {
  return useQuery({
    queryKey: footageKeys.industries(),
    queryFn: ({ signal }) => getFootageIndustries({ signal }),
    meta: {
      errorMessage: "Failed to load industries. Please try again.",
    },
    ...options,
  });
};

export const useUpdateFootage = (options = {}) => {
  return useMutation({
    mutationFn: ({ id, ...footageData }, { signal }) =>
      updateFootage(id, footageData, { signal }),
    onSuccess: (footage, variables, onMutateResult, { client }) => {
      client.setQueriesData({ queryKey: footageKeys.all }, (data) => {
        if (!data?.pages) {
          return data;
        }

        return {
          ...data,
          pages: data.pages.map((page) => ({
            ...page,
            footage: page.footage.map((item) =>
              item._id === footage._id ? footage : item,
            ),
          })),
        };
      });

      if (variables.industry !== undefined) {
        client.invalidateQueries({ queryKey: footageKeys.industries() });
      }
    },
    meta: {
      errorMessage: "Failed to update footage. Please try again.",
    },
    ...options,
  });
};
